<template>  
  <v-layout row wrap class="pa-5">  
    <v-flex xs1>
      <v-icon    
        class="outlined"                             
        @click="calculateAssets()">
        mdi-refresh
      </v-icon>
    </v-flex>
    <v-flex xs10>
      As Of: {{calculateDate}}
    </v-flex>      
    <v-flex xs1>
      <v-icon  v-if="this.assetsCurrency !='TRY'" 
        class="outlined"              
        @click="switchTRY()">
        mdi-currency-try
      </v-icon>
      <v-icon  v-if="this.assetsCurrency =='TRY'"   
      class="outlined"                             
        @click="switchUSD()">
        mdi-currency-usd
      </v-icon>
    </v-flex>                   
    <v-flex xs12 >
      <v-treeview
        :open.sync="openSync"
        :items="items"
        :dense="dense"
        :selectable="selectable"
        :activatable="activatable"
        :hoverable="hoverable"
        :open-on-click="openOnClick"
        :selected-color="selectedColor"
        :color="color"
        :shaped="shaped"
        :rounded="rounded"
      >
        <template v-slot:prepend="{ item }">
          <v-icon
            v-if="item.children"
            v-text="`mdi-${item.id === 100 ? 'basket' : item.id === 200 ? 'cash-multiple' 
                                : item.id === 300 ? 'briefcase-download' : item.id === 400 ? 'briefcase-upload' : 'folder-network'}`" 
          ></v-icon>
        </template>      
        <template v-slot:append="{ item }">
          {{item.amountFormatted}}&nbsp;&nbsp;&nbsp;{{ item.currency? item.currency.code : ""}}      
        </template>
      </v-treeview> 
    </v-flex>                                            
  </v-layout>  
</template>

<script>

import formatPrice from '../helpers/formatter';
const GET_ASSETS_API_URL = 'home/getAllAssets';
const CALCULATE_ASSETS_API_URL = 'home/calculateAssets';

export default {
  name: 'Assets',
  components: {},
  props: {
  },
  data: () => ({
    calculateDate : '',
    assetsCurrency : "TRY",
    bankAccountBalances: [],
    openSync: [100],
    items: [
      
      {
        id: 100,
        name: 'All Assets ',  
        currency : { "code":"TRY"},
        children: [
          {
            id: 200,
            name: 'Cash :',
            currency : { "code":"TRY"},
            children: [
              { id: 201,name: '',   },
              { id: 202,name: '', },
              { id: 203,name: '', },
            ],
          },
          {
            id: 300,
            name: 'Receivable :',
            children: [
              { id: 301,name: 'Sales',   },
              { id: 302,name: 'Personnel',   },
            ],
          },
          {
            id: 400,
            name: 'Payable :',
            children: [
              {id: 401, name: 'Purchase',   },
              { id: 402,name: 'Personnel', },
              { id: 403,name: 'Charity', },
            ],
          },
        ],
      },      
    ],
    dense: false,
    selectable: false,
    activatable: false,
    hoverable: true,
    openOnClick: true,
    shaped: false,
    rounded: false,
    color: 'primary',
    selectedColor: 'accent',
    selectedColors: [
      'accent',
      'teal',
      'red',
      'success',
      'warning lighten-2',
    ],
  }),
  watch: {   
    calculateDate(val){
      val;
    }     
  },
  created() {    
    this.getAllAssets();
  },
  computed: {
    bankAccountBalancesFormatted(){
      return this.bankAccountBalances.map((item) => {
        item.name = item.accountName;
        item.amountFormatted = formatPrice(item.currentBalance);
        return item;  
      })
    },   
  },
  methods: {
    switchTRY(){
      this.assetsCurrency = "TRY";
      this.getSwitchBalanceCurrency();
    },
    switchUSD(){
      this.assetsCurrency = "USD";
      this.getSwitchBalanceCurrency();
    },
    getSwitchBalanceCurrency(){
      if(this.assetsCurrency =="TRY"){
        //assets
        this.items[0].currency = { "code":"TRY"};
        this.items[0].amountFormatted = formatPrice(this.items[0].totalAssetTRY);        

        //cash
        this.items[0].children[0].currency = { "code":"TRY"};
        this.items[0].children[0].amountFormatted = formatPrice(this.items[0].children[0].totalCash);

        //receivable
        this.items[0].children[1].currency = { "code":"TRY"};
        this.items[0].children[1].amountFormatted = formatPrice(this.items[0].children[1].totalReceivable);

         //receivable - sales
        this.items[0].children[1].children[0].currency = { "code":"TRY"};
        this.items[0].children[1].children[0].amountFormatted = formatPrice(this.items[0].children[1].children[0].totalSales);

         //receivable - personnel
        this.items[0].children[1].children[1].currency = { "code":"TRY"};
        this.items[0].children[1].children[1].amountFormatted = formatPrice(this.items[0].children[1].children[1].totalPersonnel);


        //payable
        this.items[0].children[2].currency = { "code":"TRY"};
        this.items[0].children[2].amountFormatted = formatPrice(this.items[0].children[2].totalPayable);

         //payable - purchase should be here

         //payable - personnel
        this.items[0].children[2].children[1].currency = { "code":"TRY"};
        this.items[0].children[2].children[1].amountFormatted = formatPrice(this.items[0].children[2].children[1].totalPersonnel);

        //payable - charity
        this.items[0].children[2].children[2].currency = { "code":"TRY"};
        this.items[0].children[2].children[2].amountFormatted = formatPrice(this.items[0].children[2].children[2].totalCharity);

      }
      else if(this.assetsCurrency =="USD"){

        //assets
        this.items[0].currency = { "code":"USD"};
        this.items[0].amountFormatted = formatPrice(this.items[0].totalAssetUSD);

        //cash
        this.items[0].children[0].currency = { "code":"USD"};
        this.items[0].children[0].amountFormatted = formatPrice(this.items[0].children[0].totalCashUSD);

        //receivable
        this.items[0].children[1].currency = { "code":"USD"};
        this.items[0].children[1].amountFormatted = formatPrice(this.items[0].children[1].totalReceivableUSD);

        //receivable - sales
        this.items[0].children[1].children[0].currency = { "code":"USD"};
        this.items[0].children[1].children[0].amountFormatted = formatPrice(this.items[0].children[1].children[0].totalSalesUSD);

        //receivable - personnel
        this.items[0].children[1].children[1].currency = { "code":"USD"};
        this.items[0].children[1].children[1].amountFormatted = formatPrice(this.items[0].children[1].children[1].totalPersonnelUSD);


        //payable
        this.items[0].children[2].currency = { "code":"USD"};
        this.items[0].children[2].amountFormatted = formatPrice(this.items[0].children[2].totalPayableUSD);

         //payable - purchase should be here

         //payable - personnel
        this.items[0].children[2].children[1].currency = { "code":"USD"};
        this.items[0].children[2].children[1].amountFormatted = formatPrice(this.items[0].children[2].children[1].totalPersonnelUSD);
        
        //payable - charity
        this.items[0].children[2].children[2].currency = { "code":"USD"};
        this.items[0].children[2].children[2].amountFormatted = formatPrice(this.items[0].children[2].children[2].totalCharityUSD);

      }
      this.openSync = [];
    },
    getAllAssets(){     
        this.$axios.get(this.$apiurl+GET_ASSETS_API_URL)
            .then(response => {             
              this.calculateDate = response.data.asOfDate;
              this.fillAssetsInfo(response.data.assetsJson);
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    calculateAssets(){
      this.$axios.post(this.$apiurl+CALCULATE_ASSETS_API_URL, {})
      .then(response => {        
        if (response.status === 201) {         
        } 
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    fillAssetsInfo(data){   
      this.items[0].currency = { "code":"TRY"};
      this.items[0].amountFormatted = formatPrice(data.totalAsset);
      this.items[0].totalAssetTRY = data.totalAsset;
      this.items[0].totalAssetUSD = data.totalAssetUSD;

      this.bankAccountBalances = data.bankAccountsSummary.bankAccounts;
      this.items[0].children[0].name =  "Cash "   
      this.items[0].children[0].currency = { "code":"TRY"};
      this.items[0].children[0].amountFormatted = formatPrice(data.bankAccountsSummary.totalCash);
      this.items[0].children[0].totalCash = data.bankAccountsSummary.totalCash;
      this.items[0].children[0].totalCashUSD = data.bankAccountsSummary.totalCashUSD;
      this.items[0].children[0].children = this.bankAccountBalancesFormatted;

      this.items[0].children[1].name =  "Receivable "   
      this.items[0].children[1].currency = { "code":"TRY"};
      this.items[0].children[1].amountFormatted = formatPrice(data.receivableSummary.totalReceivable);
      this.items[0].children[1].totalReceivable = data.receivableSummary.totalReceivable;
      this.items[0].children[1].totalReceivableUSD = data.receivableSummary.totalReceivableUSD;
      
      this.items[0].children[1].children[0].name = "Sales"
      this.items[0].children[1].children[0].currency = { "code":"TRY"};
      this.items[0].children[1].children[0].amountFormatted = formatPrice(data.receivableSummary.sales.totalSaleReceivable);
      this.items[0].children[1].children[0].totalSales = data.receivableSummary.sales.totalSaleReceivable;
      this.items[0].children[1].children[0].totalSalesUSD = data.receivableSummary.sales.totalSaleReceivableUSD;

      this.items[0].children[1].children[1].name = "Personnel"
      this.items[0].children[1].children[1].currency = { "code":"TRY"};
      this.items[0].children[1].children[1].amountFormatted = formatPrice(data.receivableSummary.personels.totalReceivablePersonnelAmount);
      this.items[0].children[1].children[1].totalPersonnel = data.receivableSummary.personels.totalReceivablePersonnelAmount;
      this.items[0].children[1].children[1].totalPersonnelUSD = data.receivableSummary.personels.totalReceivablePersonnelAmountUSD;


      this.items[0].children[2].name =  "Payable "   
      this.items[0].children[2].currency = { "code":"TRY"};
      this.items[0].children[2].amountFormatted = formatPrice(data.payableSummary.totalPayable);
      this.items[0].children[2].totalPayable = data.payableSummary.totalPayable;
      this.items[0].children[2].totalPayableUSD = data.payableSummary.totalPayableUSD;
      
      // purchases should be here
      this.items[0].children[2].children[1].name = "Personnel"
      this.items[0].children[2].children[1].currency = { "code":"TRY"};
      this.items[0].children[2].children[1].amountFormatted = formatPrice(data.payableSummary.personels.totalPayablePersonnelAmount);
      this.items[0].children[2].children[1].totalPersonnel = data.payableSummary.personels.totalPayablePersonnelAmount;
      this.items[0].children[2].children[1].totalPersonnelUSD = data.payableSummary.personels.totalPayablePersonnelAmountUSD;

      this.items[0].children[2].children[2].name = "Charity"
      this.items[0].children[2].children[2].currency = { "code":"TRY"};
      this.items[0].children[2].children[2].amountFormatted = formatPrice(data.payableSummary.charity.totalCharityAmount);
      this.items[0].children[2].children[2].totalCharity = data.payableSummary.charity.totalCharityAmount;
      this.items[0].children[2].children[2].totalCharityUSD = data.payableSummary.charity.totalCharityAmountUSD;

    }
  }
}
</script>
<style scoped>
.v-icon.outlined {
    border: 1px solid black;
    border-radius:10%;
    height: 30px;
    width: 30px;
}
</style>